import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import MeetingRoomDevice from '@/types/table/meetingRoomDevice';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface MeetingRoomDeviceData extends MeetingRoomDevice {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class MeetingRoomDeviceController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<MeetingRoomDeviceData>>(API_CONTEXT + '/upms/meetingRoomDevice/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<MeetingRoomDeviceData>(API_CONTEXT + '/upms/meetingRoomDevice/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/meetingRoomDevice/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/meetingRoomDevice/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/meetingRoomDevice/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingRoomDevice/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingRoomDevice/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingRoomDevice/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/meetingRoomDevice/deleteBatch', params, httpOptions);
  }
}
